export default {
  fechaEmision: {
    nombre: 'Fecha de Emisión',
    tipo: 'fecha'
  },
  fechaCreacion: {
    nombre: 'Fecha de Creación',
    tipo: 'fecha'
  },
  estadoSii: {
    nombre: 'Estado SII',
    tipo: 'multi'
  },
  folio: {
    nombre: 'Folio',
    tipo: 'numero'
  },
  tipoDocumento: {
    nombre: 'Tipo Documento',
    tipo: 'multi'
  },
  rutEmisor: {
    nombre: 'RUT Emisor',
    tipo: 'rut'
  },
  rutReceptor: {
    nombre: 'RUT Receptor',
    tipo: 'rut'
  },
  estadoComercial: {
    nombre: 'Estado Comercial',
    tipo: 'multi'
  },
  codigosEtiqueta: {
    nombre: 'Etiquetas',
    tipo: 'texto'
  },
  textoObservaciones: {
    nombre: 'Observaciones/Materia',
    tipo: 'texto'
  },

  nombreArchivoCarpeta: {
    nombre: 'Nombre',
    tipo: 'texto'
  },
  tipoObjeto: {
    nombre: 'Tipo de Búsqueda',
    tipo: 'multi'
  },
  fechaModificacion: {
    nombre: 'Fecha de Modificación',
    tipo: 'fecha'
  },
  fechaVencimiento: {
    nombre: 'Fecha de Vencimiento',
    tipo: 'fecha'
  },
  fechaPublicacion: {
    nombre: 'Fecha de Publicación',
    tipo: 'fecha'
  },
  tags: {
    nombre: 'Tags',
    tipo: 'tags'
  },
  keywords: {
    nombre: 'Keywords',
    tipo: 'tags'
  },
  tipoVencimiento: {
    nombre: 'Tipo de Vencimiento',
    tipo: 'multi'
  },
  tipoExpiracion: {
    nombre: 'Tipo de Vencimiento',
    tipo: 'multi'
  },
  estadoAprobacion: {
    nombre: 'Estado de Aprobación',
    tipo: 'multi'
  },
  estadoPublicacion: {
    nombre: 'Estado de Publicación',
    tipo: 'multi'
  },
  nombre: {
    nombre: 'Nombre',
    tipo: 'texto'
  },
  DOCNUM: {
    nombre: 'Nº Documento',
    tipo: 'texto'
  },
  DOCUMENTO_MADRE: {
    nombre: 'Nº Documento Madre',
    tipo: 'texto'
  },
  EMPRESA_ID: {
    nombre: 'Empresa',
    tipo: 'selector'
  },
  TYPE_ID: {
    nombre: 'Tipo documento',
    tipo: 'selector'
  },
  ID_AUTOR: {
    nombre: 'Autor',
    tipo: 'selector'
  },
  ID_TEMA: {
    nombre: 'Tema',
    tipo: 'selector'
  },
  ID_SUBTEMA: {
    nombre: 'Subtema',
    tipo: 'selector'
  },
  MATERIA_REG: {
    nombre: 'Materia',
    tipo: 'texto'
  },
  CAMPO45: {
    nombre: 'Fecha de Documento',
    tipo: 'fecha'
  }
};
